import React from 'react';
import { MainPageLayout } from '../layout/MainPageLayout';
import { DeviceArchiveDiv } from '../component/device-archive/DeviceArchiveDiv';

export const DeviceArchivePage = () => (
  <MainPageLayout elementCentr={<DeviceArchiveDiv />} />
);
